import { mount } from 'svelte';
import App from './App.svelte';
// The design tokens belong to the component, not to this app. FlightPlanning.svelte styles itself
// entirely from custom properties (--surface, --surface-2, --accent-strong, --text-dim …) defined
// in drone-player's app.css. Importing the component without them left every token undefined:
// tooltips lost their background, selected chips lost their fill, and dim text lost its colour.
// It must come FIRST so site.css can layer on top of it rather than under it.
import '$dp/app.css';
import './site.css';

mount(App, { target: document.getElementById('app')! });
